import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/joy';
import { projectDisplayName } from '../../utils/projectDisplayName';

function importanceColor(importance) {
    switch (importance) {
        case 'critical':
            return 'danger';
        case 'high':
            return 'warning';
        case 'medium':
            return 'primary';
        default:
            return 'neutral';
    }
}

function relativeTime(ts) {
    if (ts == null) return '';
    const delta = Date.now() - ts;
    if (delta < 60_000) return 'just now';
    if (delta < 3_600_000) return `${Math.floor(delta / 60_000)}m ago`;
    if (delta < 86_400_000) return `${Math.floor(delta / 3_600_000)}h ago`;
    return new Date(ts).toLocaleString();
}

export default function EventRow({ event, dense = false }) {
    const description = event.description || '';
    const truncated =
        description.length > 120 ? `${description.slice(0, 117)}…` : description;

    return (
        <Stack
            direction="row"
            spacing={1.5}
            alignItems="flex-start"
            sx={{
                py: dense ? 0.75 : 1,
                borderBottom: '1px solid',
                borderColor: 'divider',
            }}
        >
            <Chip size="sm" variant="soft" color={importanceColor(event.importance)}>
                {event.importance || 'normal'}
            </Chip>
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                    <Typography level="body-sm" fontWeight="lg">
                        {event.type || 'event'}
                    </Typography>
                    <Typography level="body-xs" textColor="neutral.500">
                        {projectDisplayName(event.project)}
                    </Typography>
                    <Typography level="body-xs" textColor="neutral.400">
                        {relativeTime(event.ts)}
                    </Typography>
                </Stack>
                {truncated && (
                    <Typography level="body-xs" textColor="neutral.600" sx={{ mt: 0.25 }}>
                        {truncated}
                    </Typography>
                )}
            </Box>
        </Stack>
    );
}
